// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './tokens.css';
import { initTheme } from './components/ui/ThemeToggle';
import './field-notes-components.css';
import './index.css';
import App from './App';

// Apply the persisted/OS theme before first paint (no flash).
initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
